export default __webpack_public_path__ + "b2612e803290fe930a89c11930c6af8c.svg";